// 本项目所有数据均为 Mock 数据，用于大赛路演视觉展示
// 数据来源标注：基于模拟数据与行业公开报告推算

export const PROJECT_INFO = {
  name: '数师有方',
  fullName: '数师有方——数学师范生AI微格实训与县域中学"双师课堂"联动平台',
  school: '华中师范大学',
  colleges: '数学与统计学学院 + 外国语学院',
  grade: '2025级',
  teamSize: 12,
  teachers: ['[占位：A]', '[占位：B]', '[占位：C]'],
  date: '2026年5月',
};

// 区块1：首屏核心数据跑马灯
export const HERO_STATS = [
  { value: 12580, suffix: '次', label: '累计AI评价' },
  { value: 3200, suffix: '人', label: '覆盖师范生' },
  { value: 46, suffix: '所', label: '合作县域中学' },
  { value: 860, suffix: '个', label: '资源库精品片段' },
];

// 区块2：能力维度得分对比（柱状图）
export const ABILITY_DIMENSIONS = ['教学设计', '数学语言', '板书逻辑', '提问艺术', '互动设计'];
export const ABILITY_CURRENT = [62, 58, 55, 51, 48];
export const ABILITY_TARGET = [88, 90, 86, 85, 84];

// 区块2：痛点数据卡片
export const PAIN_POINTS = [
  { value: 87, suffix: '%', label: '师范生缺乏系统实训', desc: '基于模拟调研数据' },
  { value: 64, suffix: '%', label: '县域中学教师缺口', desc: '基于行业公开报告推算' },
  { value: 18, suffix: '万/间', label: '传统智慧教室硬件成本', desc: '基于市场报价估算' },
];

// 区块3：技术架构节点与连线
export const ARCH_NODES = [
  { id: '0', name: '视频上传', category: 0, symbolSize: 70 },
  { id: '1', name: '音频提取', category: 0, symbolSize: 60 },
  { id: '2', name: '画面OCR', category: 0, symbolSize: 60 },
  { id: '3', name: '大模型分析', category: 1, symbolSize: 90 },
  { id: '4', name: '五维评分', category: 1, symbolSize: 75 },
  { id: '5', name: '成长档案', category: 2, symbolSize: 65 },
  { id: '6', name: '资源社区', category: 2, symbolSize: 65 },
  { id: '7', name: '双师课堂', category: 2, symbolSize: 80 },
];

export const ARCH_LINKS = [
  { source: '0', target: '1' },
  { source: '0', target: '2' },
  { source: '1', target: '3' },
  { source: '2', target: '3' },
  { source: '3', target: '4' },
  { source: '4', target: '5' },
  { source: '4', target: '6' },
  { source: '5', target: '7' },
  { source: '6', target: '7' },
];

// 区块3：转化漏斗
export const FUNNEL_DATA = [
  { value: 100, name: '上传试讲视频' },
  { value: 85, name: 'AI多模态分析' },
  { value: 72, name: '生成改进方案' },
  { value: 58, name: '通过能力认证' },
  { value: 41, name: '参与双师课堂' },
];

// 区块4：五维雷达图数据
export const RADAR_INDICATOR = [
  { name: '教学设计', max: 100 },
  { name: '数学语言', max: 100 },
  { name: '板书逻辑', max: 100 },
  { name: '提问艺术', max: 100 },
  { name: '互动设计', max: 100 },
];

export const RADAR_DATA = {
  current: [76, 72, 68, 65, 62],
  average: [68, 64, 61, 58, 55],
  excellent: [92, 94, 89, 88, 86],
};

// 区块4：成长曲线（大一到大四）
export const GROWTH_YEARS = ['大一', '大二', '大三', '大四'];
export const GROWTH_LINES = [
  { name: '教学设计', data: [45, 58, 72, 88], color: '#fbbf24' },
  { name: '数学语言', data: [42, 56, 70, 90], color: '#06b6d4' },
  { name: '板书逻辑', data: [48, 60, 71, 85], color: '#f97316' },
  { name: '提问艺术', data: [38, 52, 66, 82], color: '#22c55e' },
  { name: '互动设计', data: [35, 48, 63, 80], color: '#a855f7' },
];

// 区块4：三维对比表
export const COMPARISON_TABLE = {
  headers: ['维度', '传统微格教室', '现有AI系统', '数师有方'],
  rows: [
    ['价格', '18万元/间', '5-8万元/校', '轻量SaaS，千元级'],
    ['部署', '重硬件、周期长', '需定制摄像头', '手机/电脑即可'],
    ['评价维度', '主观打分', '通用课堂行为', '数学学科五维模型'],
    ['学科针对性', '弱', '中等', '数学师范专用'],
    ['数据沉淀', '纸质档案', '碎片化', '四年成长档案+聚类分析'],
    ['社会出口', '无', '有限', '县域双师课堂闭环'],
  ],
};

// 区块5：市场规模细分
export const MARKET_SEGMENTS = [
  { value: 42, name: '师范院校' },
  { value: 23, name: '数学教育专业' },
  { value: 21, name: '县域中学' },
  { value: 14, name: '教资备考' },
];

// 区块5：SWOT
export const SWOT_DATA = {
  S: { title: '优势 Strengths', items: ['数学学科专用五维模型', '数统学院算法支撑', '轻量化SaaS部署'] },
  W: { title: '劣势 Weaknesses', items: ['品牌认知待建立', '教师使用习惯培养', '初期数据样本有限'] },
  O: { title: '机会 Opportunities', items: ['强师计划政策红利', '县中振兴需求迫切', '教育数字化加速'] },
  T: { title: '威胁 Threats', items: ['通用AI产品跨界', '数据隐私合规要求', '院校预算周期限制'] },
};

// 区块5：竞品对比雷达图
export const COMPETITOR_DIMENSIONS = ['价格', '部署难度', '数学针对性', '数据沉淀', '社会出口', '开放性'];
export const COMPETITOR_DATA = [
  { name: '数师有方', value: [95, 92, 96, 94, 93, 88] },
  { name: '通用课堂AI', value: [60, 55, 45, 60, 40, 70] },
  { name: '传统微格厂商', value: [30, 25, 50, 35, 30, 40] },
  { name: '教资培训平台', value: [75, 85, 55, 50, 35, 65] },
  { name: '高校自研系统', value: [50, 40, 60, 55, 45, 35] },
];

// 区块6：商业模式画布
export const BUSINESS_MODEL = [
  { title: '客户细分', content: '师范院校、数学师范生、县域中学、教育局、教资备考用户' },
  { title: '价值主张', content: '低成本、高频率、学科专用、数据驱动的师范生教学能力成长引擎' },
  { title: '渠道通路', content: '院校合作试点、师范生社群、教育展会、县域教育局推介' },
  { title: '客户关系', content: '校内导师入驻、AI助教陪伴、县域双师课堂持续运营' },
  { title: '收入来源', content: 'SaaS订阅、能力认证、内容分润、双师课堂服务、政府项目' },
  { title: '核心资源', content: '五维评价算法、精品微课库、师范生成长数据、合作中学网络' },
  { title: '关键业务', content: 'AI微格评价、成长档案、资源社区运营、双师课堂匹配' },
  { title: '重要合作', content: '师范院校、县域中学、AI技术伙伴、教育出版社、教育局' },
  { title: '成本结构', content: '研发投入、服务器与算力、市场推广、人力成本、运营管理' },
];

// 区块6：收入结构饼图
export const REVENUE_STRUCTURE = [
  { value: 40, name: 'To B 院校订阅' },
  { value: 30, name: 'To C 个人用户' },
  { value: 20, name: 'To G 政府项目' },
  { value: 10, name: '内容合作分润' },
];

// 区块6：成本结构柱状图
export const COST_STRUCTURE = {
  categories: ['研发', '服务器', '推广', '人力', '其他'],
  data: [35, 18, 22, 20, 5],
};

// 区块7：财务预测
export const FINANCE_YEARS = ['Year1', 'Year2', 'Year3', 'Year4', 'Year5'];
export const FINANCE_REVENUE = [50, 180, 420, 800, 1500];
export const FINANCE_PROFIT_RATE = [-40, -15, 8, 18, 25];

// 区块7：KPI 卡片
export const FINANCE_KPIS = [
  { value: 2950, suffix: '万', label: '五年累计营收' },
  { value: 18, suffix: '个月', label: '预计盈亏平衡' },
  { value: 800, suffix: '万', label: 'Pre-A轮估值' },
];

// 区块7：融资计划
export const FINANCING_PLAN = [
  { round: '天使轮', amount: '100万', usage: 'MVP研发、5所院校试点、算法打磨' },
  { round: 'Pre-A轮', amount: '500万', usage: '产品商业化、县域拓展、团队扩充' },
  { round: 'A轮', amount: '2000万', usage: '全国师范院校推广、双师课堂规模化' },
];

// 区块8：团队能力标签
export const TEAM_TAGS = [
  'NLP算法',
  '数据可视化',
  '前端架构',
  '回归建模',
  '聚类分析',
  '国际化文案',
  '教育产品设计',
  '音视频处理',
];

// 区块9：发展路线图
export const ROADMAP = [
  { time: '2026.05', title: 'MVP验证', desc: '完成核心五维AI评价，落地华中师范大学试点' },
  { time: '2026.12', title: '院校推广', desc: '拓展至5所师范院校，覆盖师范生5000人' },
  { time: '2027.06', title: '县域扩张', desc: '接入20所县域中学，双师课堂常态化运行' },
  { time: '2028.05', title: '百校覆盖', desc: '服务100所院校，沉淀百万级评价数据' },
  { time: '2029.05', title: '标准参考', desc: '形成数学师范生能力评价国家标准参考方案' },
];

// 区块9：社会价值量化卡片
export const SOCIAL_VALUES = [
  { title: '经济价值', value: '80%', label: '降低硬件成本', desc: '以SaaS替代18万元/间智慧教室' },
  { title: '教育价值', value: '10倍', label: '评价效率提升', desc: 'AI分钟级反馈替代小时级人工评课' },
  { title: '社会价值', value: '5000', suffix: '人次/年', label: '输送优质师资', desc: '师范培养-县域帮扶闭环' },
  { title: '青年价值', value: '100%', label: '师范生参与', desc: '构建大学四年可持续成长档案' },
];

// 区块9：影响力网络图节点
export const IMPACT_NODES = [
  { id: '0', name: '数师有方', symbolSize: 100, category: 0 },
  { id: '1', name: '师范院校', symbolSize: 70, category: 1 },
  { id: '2', name: '县域中学', symbolSize: 70, category: 1 },
  { id: '3', name: '教育局', symbolSize: 60, category: 2 },
  { id: '4', name: '出版社', symbolSize: 55, category: 2 },
  { id: '5', name: 'AI伙伴', symbolSize: 60, category: 2 },
  { id: '6', name: '师范生', symbolSize: 55, category: 1 },
  { id: '7', name: '县域学生', symbolSize: 55, category: 1 },
];

export const IMPACT_LINKS = [
  { source: '0', target: '1' },
  { source: '0', target: '2' },
  { source: '0', target: '3' },
  { source: '0', target: '4' },
  { source: '0', target: '5' },
  { source: '1', target: '6' },
  { source: '2', target: '7' },
  { source: '3', target: '2' },
  { source: '4', target: '1' },
  { source: '5', target: '0' },
];

// 区块10：参考文献（GB/T 7714 格式示例）
export const REFERENCES = [
  '教育部. 新时代基础教育强师计划[EB/OL]. (2022-04-02).',
  '国务院办公厅. 关于新时代推进普通高中育人方式改革的指导意见[EB/OL]. (2019-06-11).',
  '祝智庭, 胡姣. 智能教育的发展趋势与关键特征[J]. 开放教育研究, 2022, 28(1): 13-25.',
  '何克抗. 教育信息化与教育深化改革[EB/OL]. (2023-05-10).',
  '王小明. 师范生教学能力评价指标体系的建构[J]. 教师教育研究, 2021, 33(4): 45-52.',
  '中国教育装备行业协会. 2024年中国智慧教室行业市场研究报告[R]. 北京: 中国教育装备行业协会, 2024.',
  'BLOOM B S. Taxonomy of educational objectives: The classification of educational goals[M]. New York: Longman, 1956.',
  '国家统计局. 中国统计年鉴2024[M]. 北京: 中国统计出版社, 2024.',
];
